import * as React from 'react';
import { connect } from 'react-redux';
import Policy from './../Policies/Policy';
import ProfileNavMobile from './../ProfileNavigation/ProfileNavMobile';
import Notification from './../Policies/Notification';
import Carousel from './../Carousel/Carousel';
import LinkPolicy from './../LinkPolicy/LinkPolicy';
import './Profile.css';
import { slide as Menu } from "react-burger-menu";
import { Image } from 'react-bootstrap/';
import ProfileNavDesktop from '../ProfileNavigation/ProfileNavDesktop';
import { toggleProfile } from '../../actions/profileActions';
import SpecialDebitCard from '../SpecialDebit/SpecialDebitCard'


class Profile extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
        };

        this.handleProfileToggle = this.handleProfileToggle.bind(this);
    }

    handleProfileToggle() {
        this.props.dispatchToggleProfile();
    }

    render() {
        const { profile, firebase } = this.props;

        let inProgressDesktop = <>
            <div className="pl-lg-0 col-12 invisible">
                <div className="d-none d-lg-block d-md-none" id="ProgressDesktop">
                    <div className="col-lg-12 pb-lg-3">
                        <p className="font-weight-bold In-progress">In progress</p>
                        <Notification type="Claim" eventNumber="5" status="Done" header="Geyser claim" description="Fix interior damages" claimNumber="20/8172345" />
                        <Notification type="Reminder" header="Self-Inspection" description="2019 Hyundai Creta 1.8TD" status="Pending" />
                    </div>
                </div>
            </div>
        </>

        let inProgressMobile = <>
            <div className="ml-2 mr-2 invisible">
                <p className="font-weight-bold In-progress">In progress</p>
                <div className="row ">
                    <Notification type="Claim" eventNumber="5" status="Done" header="Geyser claim" description="Fix interior damages" claimNumber="20/8172345" />
                    <Notification type="Reminder" header="Self-Inspection" description="2019 Hyundai Creta 1.8TD" status="Pending" />
                </div>
            </div>
        </>

        let defaultImage = "./Images/Avatar/avatar-male-robot-32px-32px.svg"
        if (profile.gender === "F") {
            defaultImage = "./Images/Avatar/avatar-female-robot-32px-32px.svg";
        }

        return (
            <>
                <div id="profileMenu" className="ssp-topnav-profile-menu">
                    <Menu id="profileBM"
                        outerContainerId="App"
                        pageWrapId="profileMenu"
                        right
                        customBurgerIcon={
                            <Image id="profileBM-btn" src={(firebase.auth.photoURL) ? (firebase.auth.providerData[0].providerId === "facebook.com" ? firebase.auth.photoURL + "?type=normal" : firebase.auth.photoURL) : defaultImage} alt="" title="" />
                        }

                        isOpen={profile.showProfile}
                        onStateChange={this.handleProfileToggle}
                        style={{ "margin-top:": "52px" }}
                    >
                        <div className="row d-block on-top Profile">
                            <div id="profileFlex" className="flex-column">
                                <div className="col-12">
                                    <ProfileNavDesktop />
                                </div>
                                <div className="col-12 pl-0">
                                    <hr className="profile-divider" />
                                </div>
                                {(profile.isLinked) &&
                                    <>
                                        <div className="col-12">
                                            <Policy />
                                        </div>
                                        {inProgressDesktop}
                                    </>
                                }
                                {(!profile.isLinked) &&
                                    <>
                                        <div className="col-12 row text-left">
                                            <p className="col-12 mb-0 ml-2">No. of policies</p>
                                            <h3 className="col-12 policies-active ml-2">None active</h3>
                                        </div>
                                        <div className="col-12">
                                            <LinkPolicy />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </Menu>
                </div>
                {profile.showMobileProfile &&
                    <div className="d-block d-lg-none d-md-block carousel-push dashboard-mobile-carousel-location">
                        <Carousel />
                        <div className="pl-3 pr-3">
                            <ProfileNavMobile />
                        </div>
                        {profile.isLinked &&
                            <>
                                <div className="pl-3 pr-3">
                                    <Policy />
                                </div>

                        {profile.hasSpecialDebitDate &&
                            <>
                                    <div className="pl-3 pr-3 pt-4">
                                        <SpecialDebitCard />
                                    </div>
                            </>
                        }
                                
                                {inProgressMobile}
                            </>
                        }
                        {!profile.isLinked &&
                            <div className="pl-3 pr-3">
                                <LinkPolicy />
                            </div>
                        }
                    </div>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchToggleProfile: () => dispatch(toggleProfile()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Profile);